import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { ButtonLink } from "app/components/ui/ButtonLink/ButtonLink";
import { ChevronLeftIcon } from "app/components/icons/navigation/ChevronLeftIcon";
import { Button } from "app/components/ui/Button/Button";
import styles from "./BackButton.module.scss";
import { useIntl } from "react-intl";

export const BackButton = ({ className, onClick, to, ...props }) => {
	const { track } = useAnalytics();

	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { formatMessage } = useIntl();

	const handleClick = useCallback(() => {
		track("back_button_header_click", { url: pathname });
		onClick?.();

		if (!to) {
			navigate(-1);
		}
	}, [pathname, onClick, navigate, to]);

	const buttonClassName = classNames(styles["back-button"], className);

	const commonProps = {
		variant: "borderless",
		size: "icon-lg",
		startIcon: <ChevronLeftIcon />,
		className: buttonClassName,
		onClick: handleClick,
		"data-testid": "back-button",
		"aria-label": formatMessage({ id: "general.back" }),
		...props,
	};

	return to ? <ButtonLink to={to} replace {...commonProps} /> : <Button {...commonProps} />;
};

BackButton.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
